"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getYupProxy = exports.toString = exports.replacer = exports.INTERNAL_PROPERTIES = void 0;
/* eslint-disable @typescript-eslint/ban-ts-comment */
const DeepProxy = require("proxy-deep");
const yup = require("yup");
exports.INTERNAL_PROPERTIES = [
    "call",
    "apply",
    "bind",
    "prototype",
    "refs",
    "list",
    "type",
    "deps",
    "_typeError",
    "_nodes",
    "_whitelistError",
    "_blacklistError",
    "_whitelist",
    "_blacklist",
    "_mutate",
    "_excludedEdges",
    "_sortErrors",
    "exclusiveTests",
    "conditions",
    "tests",
    "transforms",
    "spec",
];
const ARGUMENT_SEPERATOR = "<&&&>";
function replacer(key, value) {
    if (exports.INTERNAL_PROPERTIES.includes(key))
        return undefined;
    return value;
}
exports.replacer = replacer;
const toString = (that) => `yup.${that.path.join(".").replace(/\.\(/gi, "(")}`;
exports.toString = toString;
const transformArguments = (argument) => {
    var _a, _b, _c;
    if ((_a = argument) === null || _a === void 0 ? void 0 : _a.__json_representation) {
        return (_b = argument.__json_representation) === null || _b === void 0 ? void 0 : _b.root;
    }
    if (((_c = argument) === null || _c === void 0 ? void 0 : _c.objType) === "regexp") {
        return argument;
    }
    if (typeof argument === "object" && argument !== null) {
        return Object.fromEntries(Object.entries(argument).map(([key, value]) => {
            var _a;
            return [
                key,
                (_a = value === null || value === void 0 ? void 0 : value.__json_representation) === null || _a === void 0 ? void 0 : _a.root,
            ];
        }));
    }
    return argument;
};
const getYupProxy = () => {
    const argumentMap = {};
    const toRawArguments = (pathSement) => {
        if (pathSement.startsWith("(") && pathSement.endsWith(")")) {
            const pathSegmentNoBrackets = pathSement.substring(1, pathSement.length - 1);
            const isSchemaOrShape = pathSegmentNoBrackets.includes("yup");
            if (!pathSegmentNoBrackets.includes(ARGUMENT_SEPERATOR) ||
                (!isSchemaOrShape &&
                    pathSegmentNoBrackets.split(ARGUMENT_SEPERATOR).length < 2) ||
                isSchemaOrShape)
                return transformArguments(argumentMap[pathSegmentNoBrackets]);
            return pathSegmentNoBrackets
                .split(ARGUMENT_SEPERATOR)
                .map((pathSegmentPartial) => {
                return transformArguments(argumentMap[pathSegmentPartial]);
            });
        }
        return pathSement;
    };
    const toJSONrep = (that) => ({
        root: that.path.map(toRawArguments),
    });
    // @ts-ignore
    return new DeepProxy(yup, {
        get(target, key, receiver) {
            if (key === "__path")
                return (0, exports.toString)(this);
            if (key === "__path_array")
                return this.path;
            if (key === "__argumentMap")
                return argumentMap;
            if (key === "__json_representation")
                return toJSONrep(this);
            if (key === "toString" || key === "toJSON")
                return exports.toString.bind(this, this);
            const val = Reflect.get(target, key, receiver);
            if (exports.INTERNAL_PROPERTIES.includes(key))
                return val;
            if (val && !["string", "number", "boolean"].includes(typeof val)) {
                return this.nest(val);
            }
            return val;
        },
        apply(target, thisArg, argList) {
            if ((target === null || target === void 0 ? void 0 : target.name) === "clone")
                return target.call(thisArg, ...argList);
            const val = target.call(thisArg, ...argList);
            if (val) {
                this.path.push(`(${argList
                    .map((arg) => {
                    let s = JSON.stringify(arg, replacer);
                    if (arg instanceof RegExp) {
                        s = JSON.stringify({
                            objType: "regexp",
                            value: arg.source,
                            flags: arg.flags,
                        }, replacer);
                        argumentMap[s] = JSON.parse(s);
                    }
                    else {
                        s = s === null || s === void 0 ? void 0 : s.replace(/\\+"/gi, '"');
                        s = s === null || s === void 0 ? void 0 : s.replace(/:"/gi, ":");
                        s = s === null || s === void 0 ? void 0 : s.replace(/",/gi, ",");
                        s = s === null || s === void 0 ? void 0 : s.replace(/"}/gi, "}");
                        argumentMap[s] = arg;
                    }
                    return s;
                })
                    .join(ARGUMENT_SEPERATOR)})`);
                return this.nest(val);
            }
            return this.path;
        },
    });
};
exports.getYupProxy = getYupProxy;
